import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";
import OpsPortal from "@/portals/OpsPortal";
import BusinessPortal from "@/portals/BusinessPortal";
import PartnerPortal from "@/portals/PartnerPortal";
import CabPlayer from "@/portals/CabPlayer";
import LandingPage from "@/pages/LandingPage";
import AdvertiserSignup from "@/pages/AdvertiserSignup";
import DriverSignup from "@/pages/DriverSignup";

// Subdomain locking: map hostname prefix -> forced portal.
const SUBDOMAIN_MAP = { ops: "/ops", app: "/business", partner: "/partner" };
function lockedPortal() {
  const host = window.location.hostname.split(".")[0];
  return SUBDOMAIN_MAP[host] || null;
}

function App() {
  const locked = lockedPortal();
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={locked ? <Navigate to={locked} replace /> : <LandingPage />} />
            <Route path="/signup/advertiser" element={<AdvertiserSignup />} />
            <Route path="/signup/driver" element={<DriverSignup />} />
            <Route path="/ops" element={<Navigate to="/ops/dashboard" replace />} />
            <Route path="/ops/:screen/*" element={<OpsPortal />} />
            <Route path="/business" element={<Navigate to="/business/overview" replace />} />
            <Route path="/business/:screen/*" element={<BusinessPortal />} />
            <Route path="/partner" element={<Navigate to="/partner/today" replace />} />
            <Route path="/partner/:screen/*" element={<PartnerPortal />} />
            <Route path="/cab/:plate" element={<CabPlayer />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;